import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./AuthProvider";

const OAuth2RedirectHandler = () => {
  const navigate = useNavigate();
  const { refreshUserData } = useAuth();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");

    if (token) {
      localStorage.setItem("token", token);

      refreshUserData().then(() => {
        navigate("/"); // ou outra rota após login
      });
    } else {
      console.error("Token não encontrado na URL de redirecionamento.");
      navigate("/erro-login"); // opcional
    }
  }, [navigate, refreshUserData]);

  return <p>Realizando login...</p>;
};

export default OAuth2RedirectHandler;
